<div *ngIf="!isHandset else mobileTemplate">
  <div class="filterBox" [@filterSlideIn]="show" libDraggable [dragHandle]="'.card-header'" [dragTarget]="'.filterBox'" [accompanyingTranslationDuration]="275" style="height: auto; padding: 0; width: auto;">
    <div class="card entryForm" [ngClass]="{'activate': showIndividual}" style="border: none;">
      <div class="card-header imgIndividualHeader">
          Image Individual Search
          <div class="close" title="Close" (click)="close()">&times;</div>
      </div>
      <div class="card-body">
        <form name="individualEditForm" id="individualEditForm" autocomplete="off">
          <div *ngIf="loaded; else pleaseWait" class="card-text">
            <div class="row">
              <div class="col-5" style="float: left; margin-right: 1em;">
                <label for="imgIndFirstName">First Name</label>
                <input type="text" name="imgIndFirstName" class="col form-control editable" placeholder="First Name" autofocus id="firstNameInput" 
                  [(ngModel)]="data.firstName" 
                  [focusFirst]="false" maxlength="400"
                  (focus)="fNameFocus$.next($any($event).target.value)"
                  (click)="fNameClick$.next($any($event).target.value)"
                  [autocomplete]="'off'">
              </div>
              <div class="col-5" style="float: left; margin-right: 1em;">
                <label for="imgIndFirstName">Last Name</label>
                <input type="text" name="imgIndLastName" class="col form-control editable" placeholder="Last Name" maxlength="400" id="lastNameInput"
                  [(ngModel)]="data.lastName"
                  [focusFirst]="false"
                  (focus)="lNameFocus$.next($any($event).target.value)"
                  (click)="lNameClick$.next($any($event).target.value)"
                  [autocomplete]="'off'">
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-3">
                <div style="float: left;">                  
                  <label style="width: 13em;">Rank Category</label>
                  <mat-form-field floatLabel="never" class="compact-dropdown">
                    <mat-select [(value)]="data?.rank.rankCategoryId" id="rankCatDropdown" [typeaheadDebounceInterval]="dropdownTypeDebounceTime" aria-placeholder="rank category" (selectionChange)="filterRanksByCat($event.value)">
                      <mat-option value="-1">None</mat-option>
                      <mat-option *ngFor="let rc of rankCats" [value]="rc.uid">{{ rc.rankCategory }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-1"></div>
              <div class="col-3">
                <div style="float: left;">                  
                  <label style="width: 13em;">Rank</label>
                  <mat-form-field floatLabel="never" class="compact-dropdown">
                    <mat-select [(value)]="data.rankId" aria-placeholder="rank for individual"  [typeaheadDebounceInterval]="dropdownTypeDebounceTime" id="rankDropdown" (selectionChange)="updateRank($event.value)">
                      <mat-option value="-1">None</mat-option>
                      <mat-option *ngFor="let r of ranksFiltered" [value]="r.uid">{{ r.rankName }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>  
            </div>
            <hr>
            Unit
            <app-unit-picker #unitPicker [regiments]="regiments" [states]="states" [branches]="branches" [coLetters]="coLetters" [singleUnitMode]="true"
              (unitSelected)="updateUnit($event)"></app-unit-picker>
          </div>
          
          <div style="float: right; margin-right: 1em; margin-top: 1em;">
            <app-slant-button btnColor="green" class="me-2" [disabled]="!loaded" submitMode="true" (click)="runSearch()" btnIconClass="fa-search">Search</app-slant-button>
            <app-slant-button btnColor="gray" class="me-2" [disabled]="!loaded" (click)="reset(true)" btnIconClass="fa-backspace">Clear</app-slant-button>
            <app-slant-button btnColor="yellow" class="me-2" (click)="close()" btnIconClass="fa-ban">Cancel</app-slant-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<ng-template #pleaseWait>
  Loading data, please wait...
  <br><br>
</ng-template>
<ng-template #unknownName>
  <span class="individualName text-muted">(Name unknown)</span>
</ng-template>


<ng-template #mobileTemplate>

  <div class="filterBox mobile" [@filterSlideIn]="show" libDraggable [dragHandle]="'.card-header'" [dragTarget]="'.filterBox'"  style="padding: 0;">
    
    <div class="card entryForm" [ngClass]="{'activate': showIndividual}" style="border: none; top: 0; width: 100vw; height: 70vh;">
      <div class="card-header imgIndividualHeader">
          Image Individual Search
          <div class="close" title="Close" (click)="close()">&times;</div>
      </div>

      <div class="card-body">
        <form name="individualEditForm" id="individualEditForm" autocomplete="off">
          <div *ngIf="loaded; else pleaseWait" class="card-text">
            <div class="row" style="justify-content: center;">
              <div class="col-6">
                <label for="imgIndFirstName">First Name</label>
                <input type="text" name="imgIndFirstName" class="col form-control editable" placeholder="First Name" autofocus id="firstNameInput" 
                  [(ngModel)]="data.firstName" 
                  [focusFirst]="false" maxlength="400"
                  (focus)="fNameFocus$.next($any($event).target.value)"
                  (click)="fNameClick$.next($any($event).target.value)"
                  [autocomplete]="'off'">
              </div>
              <div class="col-6">
                <label for="imgIndFirstName">Last Name</label>
                <input type="text" name="imgIndLastName" class="col form-control editable" placeholder="Last Name" maxlength="400" id="lastNameInput"
                  [(ngModel)]="data.lastName"
                  [focusFirst]="false"
                  (focus)="lNameFocus$.next($any($event).target.value)"
                  (click)="lNameClick$.next($any($event).target.value)"
                  [autocomplete]="'off'">
              </div>
            </div>
            <hr>

            <div class="row" style="justify-content: center;">
              <div class="col-6">
                <div>                  
                  <label>Rank Category</label>
                  <mat-form-field floatLabel="never" class="formField compact-dropdown" >
                    <mat-select [(value)]="data?.rank.rankCategoryId" id="rankCatDropdown" [typeaheadDebounceInterval]="dropdownTypeDebounceTime" aria-placeholder="rank category" (selectionChange)="filterRanksByCat($event.value)">
                      <mat-option value="-1">None</mat-option>
                      <mat-option *ngFor="let rc of rankCats" [value]="rc.uid">{{ rc.rankCategory }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-6">
                <div>                  
                  <label>Rank</label>
                  <mat-form-field floatLabel="never" class="formField compact-dropdown" >
                    <mat-select [(value)]="data.rankId" aria-placeholder="rank for individual" [typeaheadDebounceInterval]="dropdownTypeDebounceTime" id="rankDropdown" (selectionChange)="updateRank($event.value)">
                      <mat-option value="-1">None</mat-option>
                      <mat-option *ngFor="let r of ranksFiltered" [value]="r.uid">{{ r.rankName }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <hr>
            <span>Unit</span>
            <app-unit-picker #unitPicker [regiments]="regiments" [states]="states" [branches]="branches" [coLetters]="coLetters" [singleUnitMode]="true"
              (unitSelected)="updateUnit($event)"></app-unit-picker>
            <hr>

          </div>
          
          <div style="float: right; margin-right: 1em; margin-top: 1em;">
            <div class="row">
              <div class="col-4">
                <app-slant-button btnColor="green" class="me-2" [disabled]="!loaded" submitMode="true" (click)="runSearch()" btnIconClass="fa-search">Search</app-slant-button>
              </div>
              <div class="col-4">
                <app-slant-button btnColor="gray" class="me-2" [disabled]="!loaded" (click)="reset(true)" btnIconClass="fa-backspace">Clear</app-slant-button>
              </div>
              <div class="col-4">
                <app-slant-button btnColor="yellow" class="me-2" (click)="close()" btnIconClass="fa-ban">Cancel</app-slant-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</ng-template>